












import { defineComponent, PropType } from "@vue/composition-api";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "ProfileTagsView",
  components: { BaseButton },
  props: {
    userTags: { type: Array as PropType<TagInfo[]>, required: true },
    title: { type: String, default: $t("Categories") },
  },
});
